import React from "react";
import MobileStickyCTA from "./MobileStickyCTA";

const Home = () => (
  <section className="home" id="home">
    <h2>Your wellness, your way — on-site or on location.</h2>
    <p>Relax, Recover, Reduce Pain.</p>
    <p style={{ fontSize: "20px", fontWeight: "600" }}>
  1004 West Broadway Ave.
</p>
  </section>
);

export default Home;
